var $ = require('jquery')
  , ERROR_MSG = '网络发生了错误'
  , openAlert = require('game-info/widgets/openAlert')
  , CherishForm = require('game-info/widgets/CherishForm')

module.exports = function(e) {
  var ued = window.ued || {}
    , gameCode = ued.gameCode

  var formDiaog = new CherishForm()
  formDiaog.render().open()
}
